import axios from 'axios'
import { LISTAR_FILTROS_FECHAMENTO_CAIXA } from '../../types'
import { URL } from '../../../util/ambienteActions';

export default idEmpresa => dispatch => axios.get(`${URL}/fechamento-caixa-agencia/empresa/${idEmpresa}/filtros`)
  .then(response => dispatch({
    type: LISTAR_FILTROS_FECHAMENTO_CAIXA,
    payload: response
  }));
